import Droit from '~/scripts/services/model/droit';
import Defaults from '~/scripts/constants/defaults';
import Node from './node';

export const defaultDroit = new Droit({
	kright: Defaults.DROIT.ALL,
	role: {
		isa: 'K_NODE;KROLE',
		kid: 'K_NODE;KR_TOUS',
	},
});

export default class SchemaNode {
	/* @ngInject */
	/**
	 * @param {Node} node
	 */
	constructor(node) {
		/** @type {boolean} */
		this.existK = false;

		/** @type {string} */
		this.id = '';

		/** @type {Node} */
		this.node = node;

		/** @type {boolean} */
		this.readOnly = false;

		/** @type {boolean} */
		this.selected = false;

		/** @type {'RECTANGLE' | 'ROUNDRECT' | 'ELLIPSIS' | 'CIRCLE'} */
		this.shape = 'RECTANGLE';

		/** @type {boolean} */
		this.visible = true;

		/** @type {?number} */
		this.x = null;

		/** @type {?number} */
		this.y = null;

		if (this.node && !this.node.objtype) {
			this.node.objtype = 'CLASS';
		}

		Object.defineProperty(this, 'shapes', {
			value: [
				'RECTANGLE',
				'ROUNDRECT',
				'ELLIPSIS',
				'CIRCLE',
			],
			writable: false,
			enumerable: true,
			configurable: false,
		});
	}

	export11() {
		return {
			droit:    this.node.droit.map(droit => droit.export11()),
			existK:   this.existK,
			id:       this.id,
			isa:      this.node.isa.objid,
			kid:      this.node.kid,
			objtype:  this.node.objtype,
			repre:    this.node.repre,
			readOnly: this.readOnly,
			shape:    this.shape,
			type_kid: this.node.type_kid,
			x:        this.x,
			y:        this.y,
		};
	}

	export() {
		return {
			existK:   this.existK,
			id:       this.id,
			kid:      this.node.kid,
			readOnly: this.readOnly,
			shape:    this.shape,
			x:        this.x,
			y:        this.y,
		};
	}

	/**
	 * @returns {string|undefined}
	 */
	getName() {
		return this.node.getName(true);
	}

	/**
	 * @returns {boolean}
	 */
	isVisible() {
		return this.visible;
	}

	hide() {
		this.visible = false;
	}

	show() {
		this.visible = true;
	}
}
